import * as API from "middleware/api";

export const listAccountStatements = (year) =>
    API.executeWithAccessToken("/corporateCard.accountStatements.list", {
        year,
    });

export const downloadAccountStatement = (fileName) =>
    API.executeWithAccessToken("/corporateCard.accountStatements.download", {
        fileName,
    });
